/**
 * Product Upsells - Quick Options Integration
 * Delegates multi-variant "View options" buttons to the Quick View drawer (quick-view.js)
 */
(function() {
  'use strict';

  function initializeQuickOptionsButtons(container) {
    var buttons = container.querySelectorAll('.button-quick-options');

    buttons.forEach(function(button) {
      if (button.dataset.quickViewBound === 'true') return;
      button.dataset.quickViewBound = 'true';

      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        var handle = button.getAttribute('data-handle');
        if (!handle) return;

        document.dispatchEvent(new CustomEvent('quickview:open', {
          detail: { handle: handle },
          bubbles: true
        }));
      });
    });
  }

  function watchProductRecommendations() {
    var recs = document.querySelectorAll('product-recommendations');

    recs.forEach(function(el) {
      if (el.dataset.quickViewWatched === 'true') return;
      el.dataset.quickViewWatched = 'true';

      initializeQuickOptionsButtons(el);

      var observer = new MutationObserver(function() {
        initializeQuickOptionsButtons(el);
      });
      observer.observe(el, { childList: true, subtree: true });
    });
  }

  function start() {
    watchProductRecommendations();

    var bodyObserver = new MutationObserver(function() {
      watchProductRecommendations();
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/**
 * Product Upsells - AJAX Add to Cart
 * Handles single-variant direct add-to-cart forms within upsells
 */
(function() {
  'use strict';

  function initializeForms() {
    var forms = document.querySelectorAll('.product-upsells__form--ajax');

    forms.forEach(function(form) {
      if (form.dataset.ajaxInitialized === 'true') return;
      form.dataset.ajaxInitialized = 'true';

      form.addEventListener('submit', function(e) {
        e.preventDefault();

        var button = this.querySelector('button[type="submit"]');
        var spinner = this.querySelector('.loading-overlay__spinner');
        var buttonText = button.querySelector('span');
        var originalText = buttonText.textContent;

        button.disabled = true;
        spinner.classList.remove('hidden');
        buttonText.textContent = 'Adding...';

        var formData = new FormData(this);

        var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cart && typeof cart.getSectionsToRender === 'function') {
          formData.append(
            'sections',
            cart.getSectionsToRender().map(function(section) { return section.id; })
          );
          formData.append('sections_url', window.location.pathname);
        }

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        })
        .then(function(response) { return response.json(); })
        .then(function(data) {
          if (data.status) {
            button.disabled = false;
            spinner.classList.add('hidden');
            buttonText.textContent = 'Error';
            setTimeout(function() { buttonText.textContent = originalText; }, 2000);
            return;
          }

          button.disabled = false;
          spinner.classList.add('hidden');
          buttonText.textContent = originalText;

          if (cart && typeof cart.renderContents === 'function') {
            cart.renderContents(data);
            setTimeout(function() {
              if (cart.classList.contains('is-empty')) {
                cart.classList.remove('is-empty');
              }
            }, 100);
          } else {
            window.location.href = window.Shopify.routes.root + 'cart';
            return;
          }

          document.documentElement.dispatchEvent(
            new CustomEvent('cart:refresh', { bubbles: true })
          );
          document.dispatchEvent(
            new CustomEvent('cart:updated', { detail: data })
          );
        })
        .catch(function(error) {
          console.error('[Product Upsells] Error adding to cart:', error);

          button.disabled = false;
          spinner.classList.add('hidden');
          buttonText.textContent = 'Error - Try again';

          setTimeout(function() {
            buttonText.textContent = originalText;
          }, 2000);
        });
      });
    });
  }

  function start() {
    initializeForms();

    var observer = new MutationObserver(function() {
      initializeForms();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();